<zf-loading-indicator
    *ngIf="(hasOrgs() && !orgNodes()) || (!accounts() && !showPartialCreatedAccountInfo())"></zf-loading-indicator>

<div class="main-container">
    <div class="side-container">
        <zf-sidebar *ngIf="!!accounts()?.length"></zf-sidebar>
    </div>
    <div *ngIf="!hasOrgs()" class="content">
        <div *ngIf="!!accounts()?.length" class="table-container">
            <h3 class="title">Make a Selection to Proceed</h3>
            <table class="stretched">
                <thead>
                    <tr class="bordered-top-bottom">
                        <th>System ID</th>
                        <th>Company</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="dashed-border-bottom" *ngFor="let account of accounts()" (click)="pickAccount(account)">
                        <td>{{ account.accountId }}</td>
                        <td>{{ account.accountCompany }} <span *ngIf="account.isMasterUser" class="master-user">Master
                                User</span></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div *ngIf="showPartialCreatedAccountInfo()" class="super-user-container">
            <h3>Thanks for logging into FortinetOne. It appears that you only have a partially completed registered
                account.
                In order to get access to all the services in FortinetOne, please click <a
                    href="https://support.fortinet.com/Main.aspx">here</a>
                to complete your registration. For any issues please contact <a
                    href="mailto:cs@fortinet.com">cs&#64;fortinet.com</a></h3>
        </div>


    </div>
    <div *ngIf="hasOrgs()" class="content">
        <div *ngIf="!!orgNodes()" class="list-container">
            <zf-org-chooser *ngIf="hasOrgs()" [orgNodes]="orgNodes()" [withSearch]="false"></zf-org-chooser>
        </div>
    </div>
</div>
